import { useAllListings } from 'app/network/listing';
import { ListingType, type TransactionMode } from 'app/types/listing';
import {
  DASHBOARD_LAYOUT_DEFAULT_LAYOUT,
  DASHBOARD_LAYOUT_DEFAULT_WITH_MESSAGE_FOOTER,
} from 'app/hooks/with-dashboard-layout';
import { createTheme as createDSTheme } from 'app/shopify';

export const theme = createDSTheme();

export const ALL_TRANSACTION_MODES = 'all' as const;

export type TransactionModeTab = TransactionMode | typeof ALL_TRANSACTION_MODES;

export const getCountLabel = (count?: number) => (count === undefined ? undefined : count.toString());

export function useOfferListingCount({
  enabled,
  transactionMode,
  userId,
}: {
  enabled: boolean;
  transactionMode?: TransactionMode;
  userId?: string;
}) {
  const filters = {
    type: ListingType.offer,
    userId,
    take: 1,
    transactionMode,
  };

  return useAllListings(filters, `MyListings-${transactionMode ?? ALL_TRANSACTION_MODES}-Count`, {
    enabled,
    populateListingDetailCache: false,
  });
}

export interface AlertPolyfill {
  visible: boolean;
  title: string;
  message?: string;
  buttons?: { text: string; style?: 'cancel' | 'destructive'; isPreferred?: boolean; onPress?: () => void }[];
}

export function getListingListPresentation(isLargeUI: boolean, isSelecting: boolean) {
  return {
    searchBar: 'visible' as const,
    selection: isSelecting ? ('enabled' as const) : ('disabled' as const),
    requestCard: isLargeUI ? ('highest' as const) : ('standard' as const),
    offerBanner: 'visible' as const,
  };
}

export function getMyListingsLayout(isMobileUI: boolean) {
  return isMobileUI ? DASHBOARD_LAYOUT_DEFAULT_LAYOUT : 'simpleVerticalScrolling';
}

export function getMyListingsMessageFooterVisibility(isMobileUI: boolean) {
  return isMobileUI ? DASHBOARD_LAYOUT_DEFAULT_WITH_MESSAGE_FOOTER : true;
}
